import { useContextStore } from '@/stores/context.store';

export function useContext() {
  const {
    clinicId,
    doctorId,
    clinic,
    doctor,
    hasContext,
    hasFullContext,
    isHydrated,
    setClinic,
    setDoctor,
    clearContext,
    clearDoctor
  } = useContextStore();

  return {
    clinicId,
    doctorId,
    clinic,
    doctor,
    hasContext,
    hasFullContext,
    isHydrated,
    setClinic,
    setDoctor,
    clearContext,
    clearDoctor,
  };
}